export default (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props}>
        <use xlinkHref="#pencilsymbol" />
    </svg>
);
